import React from 'react'
import WizSelect from '../../../components/select/WizSelect'
import {getValueFromId} from '../../../components/select/constSelect'
import Text from '../../../components/text/Text'

interface IProps {
    className?: string
    onChangedSelect?: (e: string) => void
    status?: string
    isOnlyRetry?: boolean
    setIsOnlyRetry?: (e: boolean) => void
}

const WithdrawSearchContainer: React.FC<IProps> = ({
    className,
    status = '',
    onChangedSelect,
    isOnlyRetry,
    setIsOnlyRetry,
}) => {
    return (
        <div className={'flex items-center justify-between'}>
            <div className={'flex gap-x-[10px] items-center sm:items-start sm:flex-col sm:gap-y-[10px]'}>
                <WizSelect
                    disabled={isOnlyRetry}
                    optionKey="status"
                    onChange={item => {
                        onChangedSelect(item as string)
                    }}
                    value={getValueFromId('status', status)}
                />
                <div
                    onClick={() => {
                        setIsOnlyRetry(!isOnlyRetry)
                    }}
                    className={`py-[5px] px-[12px] border rounded-[5px] cursor-pointer ${
                        isOnlyRetry ? 'border-font_red' : 'border-font04'
                    }`}>
                    <Text className={`${isOnlyRetry ? 'text-font_red text-ti1' : 'text-font04 text-body1'}`}>
                        Only View Possible Retry
                    </Text>
                </div>
            </div>
        </div>
    )
}

export default WithdrawSearchContainer
